import { Flujo } from '../interfaces/flujo';


export abstract class FlujosPaso3Service {
    datosAgenda: Flujo;
    configuracionCuotas: Flujo;
    cuentaAbono: Flujo;
    firmarDocumentos: Flujo;
    terminosYCondiciones: Flujo;
}
